import PersonIcon from '@mui/icons-material/Person'
import HomeIcon from '@mui/icons-material/Home'
import LanguageIcon from '@mui/icons-material/Language'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import NotesIcon from '@mui/icons-material/Notes'
import LocalPoliceIcon from '@mui/icons-material/LocalPolice'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import IosShareIcon from '@mui/icons-material/IosShare'

// The applicant wizard's steps, in order. `key` is what the requirement
// checker and the selected-step state refer to; titles are display only.
export default [
  {
    key: 'personal',
    title: 'Personal details',
    description: 'Tell us who you are and who to contact in an emergency.',
    icon: PersonIcon,
  },
  {
    key: 'address',
    title: 'Address',
    description:
      'Your current address and anywhere else you have lived in the last five years — we need this for your DBS check.',
    icon: HomeIcon,
  },
  {
    key: 'rightToWork',
    title: 'Right to work',
    description: 'Show us you are entitled to work in the UK.',
    icon: LanguageIcon,
  },
  {
    key: 'employment',
    title: 'Employment history',
    description:
      'Your full employment history, most recent first, with an explanation of any gaps.',
    icon: WorkHistoryIcon,
  },
  {
    key: 'statement',
    title: 'Supporting statement',
    description:
      'Tell us how your skills and experience make you right for the role.',
    icon: NotesIcon,
  },
  {
    key: 'qualifications',
    title: 'Qualifications',
    description: 'The role you are applying for and your professional registration.',
    icon: WorkspacePremiumIcon,
  },
  {
    key: 'dbs',
    title: 'DBS check',
    description: 'Details of any existing enhanced DBS certificate.',
    icon: LocalPoliceIcon,
  },
  {
    key: 'driving',
    title: 'Driving',
    description:
      'Your licence details so we can check your driving record with the DVLA.',
    icon: DirectionsCarIcon,
  },
  {
    key: 'references',
    title: 'References',
    description: 'Two professional referees we can contact.',
    icon: RecordVoiceOverIcon,
  },
  {
    key: 'review',
    title: 'Review & submit',
    description: 'Check everything is complete, then send us your application.',
    icon: IosShareIcon,
  },
]
